import { COMPONENT_REGISTRY } from '../componentRegistry';
import {
  BannerVariantStyles,
  PopupVariantStyles
} from '../constants/variantConfig';
import {
  BannerResolvedStyles,
  ComponentInstance,
  ComponentType,
  PopupResolvedStyles,
  ResolvedStyles,
  VariantName
} from '../types';

const resolveVariantStyles = (
  instance: ComponentInstance,
  componentType: ComponentType
): ResolvedStyles => {
  const entry = COMPONENT_REGISTRY[componentType];
  const { variantConfig, defaultVariant } = entry ?? {
    variantConfig: {},
    defaultVariant: VariantName.INFO
  };

  const variantKey =
    instance.variant in variantConfig ? instance.variant : defaultVariant;

  const variant = variantConfig[variantKey] ?? variantConfig[defaultVariant];

  const overrides = instance.configuration_overrides ?? {};

  const base = {
    titleColor: overrides.titleColor ?? variant.titleColor,
    bgColor: overrides.bgColor ?? variant.bgColor,
    descriptionColor: overrides.descriptionColor ?? variant.descriptionColor,
    buttonBgColor: overrides.buttonBgColor ?? variant.buttonBgColor
  };

  if (componentType === ComponentType.BANNER) {
    const v = variant as BannerVariantStyles;
    return {
      ...base,
      icon_url: overrides.icon_url ?? v.icon_url
    } as BannerResolvedStyles;
  }

  const v = variant as PopupVariantStyles;
  return {
    ...base,
    image_url: overrides.image_url ?? v.image_url
  } as PopupResolvedStyles;
};

export default resolveVariantStyles;
